module.exports = __webpack_public_path__ + "static/media/adjust.a4ebc1c1.svg";